import {createFileRoute, redirect} from '@tanstack/react-router'
import {isAuthenticated} from "../../utils/auth.ts";
import Layout from "../../components/Layouts/Layout.tsx";
import UploadPage from "../../components/Upload/UploadPage.tsx";

export const Route = createFileRoute('/upload/')({
  beforeLoad: async () => {
    if(!isAuthenticated()) {
      throw redirect({to: '/', replace: true});
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Layout>
      <UploadPage/>
    </Layout>
  );
}
